import {ITag} from "@webng-types/write-model";
import React, {useCallback} from "react";
import {TagImage} from "./TagImage";
import {useTranslation} from "react-i18next";
import classNames from "classnames";
import loadable from "@loadable/component";
import { ChevronDown, X} from "react-feather";

const Select = loadable(() => import('react-select').then(module => module.default), {
  fallback: <div></div>
})

const components = {
  ClearIndicator: loadable(() => import('react-select').then(module => ({ default: module.components.ClearIndicator }))),
  DropdownIndicator: loadable(() => import('react-select').then(module => ({ default: module.components.DropdownIndicator }))),
  MultiValueRemove: loadable(() => import('react-select').then(module => ({ default: module.components.MultiValueRemove }))),
  Placeholder: loadable(() => import('react-select').then(module => ({ default: module.components.Placeholder }))),
  NoOptionsMessage: loadable(() => import('react-select').then(module => ({ default: module.components.NoOptionsMessage }))),
  LoadingMessage: loadable(() => import('react-select').then(module => ({ default: module.components.LoadingMessage }))),
};
/* const components = {
  DropdownIndicator: loadable(() => import('react-select').then(module => ({ default: module.components.DropdownIndicator }))),
  ValueContainer: loadable(() => import('react-select').then(module => ({ default: module.components.ValueContainer }))),
  Placeholder: loadable(() => import('react-select').then(module => ({ default: module.components.Placeholder }))),
}; */

import {
  ClearIndicatorProps,
  DropdownIndicatorProps,
  MultiValueRemoveProps,
  PlaceholderProps,
  NoticeProps,
  OptionProps,
  MultiValueProps
} from "react-select";
import {EventTagNavigationType} from "./types";
// import { NoOptionsMessage } from "react-select/dist/declarations/src/components/Menu";
// import { DropdownIndicator } from "react-select/dist/declarations/src/components/indicators";

/* import {
  DropdownIndicatorProps,
  ValueContainerProps,
  PlaceholderProps
} from "react-select"; */

const FILTER_LIST_MAX_TAGS = 12;

export type OnChangeTagsHandler = (tags: ITag[]|undefined) => void

interface LiveblogTagFilterProps {
  tags: ITag[]
  onChangeTags?: OnChangeTagsHandler
  selectedTags?: string[]
  eventTagNavigation: EventTagNavigationType
}

interface TagProps {
  tag: ITag
  selected?: boolean
  onClick?: (tag: ITag|undefined) => void
}

function Tag({tag, onClick, selected}: TagProps) {

  const onClickCallback = useCallback(() => {
    onClick && onClick(tag)
  }, [onClick, tag])

  const className = classNames(
    `tik4-tag tik4-tag--button tik4-tag--x-${tag.slug || 'id-missing'}`,
    {
      'tik4-tag--selected': selected
    }
  )

  return <React.Fragment>
    <button className={className} onClick={onClickCallback} type="button">
      <TagImage image={tag.image} className="tik4-tag__img" />
      <div className="tik4-tag__name">{tag.name}</div>
    </button>
  </React.Fragment>
}


interface SearchFilterProps {
  tags: ITag[];
  onChangeTags?: OnChangeTagsHandler;
  selectedTags?: string[];
}

function SearchFilter({ tags, onChangeTags, selectedTags }: SearchFilterProps) {
  const { t } = useTranslation("liveblog");


  const handleChange = (selectedOptions: { value: string; label: string }[] | null) => {
    if(onChangeTags) {
      onChangeTags(selectedOptions?.map(option => tags.find(tag => tag._id === option.value)!) ?? undefined)
    }
  };

  const tagOptions = tags.map(tag => ({
    value: tag._id || '',
    label: tag.name
  }));

  // const [selectedOption, setSelectedOption] = useState<SingleValue<OptionType>>(tagOptions.find(option => option.value === selectedTag) || null)
  const selectedOptions = tagOptions.filter(option => selectedTags?.includes(option.value));

  function ClearIndicator(props: ClearIndicatorProps){
    // Only show clear indicator if more than 1 value is selected
    if (!props.selectProps.value || (Array.isArray(props.selectProps.value) && props.selectProps.value.length <= 1)) {
      return null;
    }
    
    return (
      <components.ClearIndicator {...props}>
        <X className="tik4-rs__i tik4-rs__i--ci" />
      </components.ClearIndicator>
   );
  }
  function DropdownIndicator(props: DropdownIndicatorProps){
    return (
      <components.DropdownIndicator {...props}>
        <ChevronDown className="tik4-rs__i tik4-rs__i--di" />
      </components.DropdownIndicator>
    );
  }

  function MultiValueRemove( props: MultiValueRemoveProps ){
    return (
      <components.MultiValueRemove {...props} innerProps={{...props.innerProps, className: "tik4-rs__multi-value__remove"}}>
        <X className="tik4-rs__mv__i" />
      </components.MultiValueRemove>
    );
  }

  function Placeholder(props: PlaceholderProps ){
    return (
      <components.Placeholder {...props}>
        <span className="tik4-rs__placeholder__text">{props.children}</span>
      </components.Placeholder>
    );
  }

  function NoOptionsMessage(props: NoticeProps ){
    return (
      <components.NoOptionsMessage {...props}>
        <span className="tik4-rs__menu-notice__text">{props.children}</span>
      </components.NoOptionsMessage>
    );
  }

  function LoadingMessage(props: NoticeProps ){
    return (
      <components.LoadingMessage {...props}>
        <span className="tik4-rs__menu-notice__text">{props.children}</span>
      </components.LoadingMessage>
    );
  }

  function CustomOption(props: OptionProps<any>) {
    const { data } = props;
    const tag = tags.find(tag => tag._id === data.value);
    
    return (
      <div {...props.innerProps} className={classNames("tik4-rs__option", props.isFocused && "tik4-rs__option--is-focused")}>
        <div className="tik4-rs__option__container">
          {tag?.image &&
            <TagImage image={tag.image} className="tik4-rs__option__img" />
          }
          <span className="tik4-rs__option__text">{data.label}</span>
        </div>
      </div>
    );
  }

  // <div class="tik4-rs__option tik4-rs__option--is-focused css-d7l1ni-option" aria-disabled="false" id="react-select-3-option-9" tabindex="-1" role="option">Our Expertise</div>

  // function CustomSingleValue(props: SingleValueProps<any>) {
  //   const { data } = props;
  //   const tag = tags.find(tag => tag._id === data.value);
    
  //   return (
  //     <div className="tik4-rs__single-value">
  //       <div className="tik4-rs__single-value__container">
  //         <TagImage image={tag?.image} className="tik4-rs__single-value__img" />
  //         <span className="tik4-rs__single-value__text">{data.label}</span>
  //       </div>
  //     </div>
  //   );
  // }

  function CustomMultiValue(props: MultiValueProps<any>) {
    const { data, removeProps } = props;
    const tag = tags.find(tag => tag._id === data.value);
    
    return (
      <div className="tik4-rs__multi-value">
        <div className="tik4-rs__multi-value__container">
          {tag?.image &&
            <TagImage image={tag.image} className="tik4-rs__multi-value__img" />
          }
          <span className="tik4-rs__multi-value__text">{data.label}</span>
        </div>
        <MultiValueRemove 
          data={data} 
          innerProps={removeProps} 
          selectProps={props.selectProps}
        />
      </div>
    );
  }

  // <div class="tik4-rs__multi-value css-1p3m7a8-multiValue">
  //   <div class="tik4-rs__multi-value__label css-wsp0cs-MultiValueGeneric">
  //     image-test4
  //   </div>
  //   <div role="button" class="tik4-rs__multi-value__remove css-12a83d4-MultiValueRemove" aria-label="Remove image-test4">
  //     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="tik4-rs__mv__i"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
  //   </div>
  // </div>

  // function ValueContainer({children, ...props}: ValueContainerProps){
  //   return <components.ValueContainer {...props}>
  //     {children}
  //     {/* doing this to get the longest word so the select has the same with. (like standard browser select behaviour) */}
  //     ‚<div className="tik4-tfs__shadow">
  //       {tagOptions.map((tag,i) => <div key={`tik4-tfs-shadow__v-${i}`} className="tik4-tfs__shadow__v">{tag.component}</div>)}
  //     </div>
  //     </components.ValueContainer>
  // }

  // function SingleValue<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>({children, ...props}: SingleValueProps<Option, IsMulti, Group>){
  //   return <components.SingleValue {...props}>
  //     {children}
  //     {/* doing this to get the longest word so the select has the same with. (like standard browser select behaviour) */}
  //     <div className="flex flex-col">
  //       {tagOptions.map((tag) => <div>{tag.label}</div>)}

  //     </div>
  //     </components.SingleValue>
  // }

  // function Input<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>({children, ...props}: InputProps<Option, IsMulti, Group>){
  //   return <components.Input {...props}>{children}</components.Input>
  // }
  // function Placeholder({children, ...props}: PlaceholderProps){
  //   return <components.Placeholder {...props}><span className="tik4-tfs__placeholder__i">{children}</span></components.Placeholder>
  // }


  return (
    <div className="tik4-tag-filter tik4-tag-filter--tfs">
      <div className="tik4-tag-filter__label"><div className="tik4-tag-filter__label__i">{t('liveblog.tags.filter.headline')}</div></div>
      <div className="tik4-tfs-c">




        {/* {(selectedOptions.length > 0) &&
          <button className="tik4-tag-filter__r tik4-link" onClick={() => handleChange(null)} >
            <X className="tik4-icon tik4-tag-filter__r__i" /><span className="tik4-tag-filter__r__t">{t('liveblog.tags.filter.search.reset')}</span>
          </button>
        } */}

        <Select
          isMulti={true}
          aria-label={t('liveblog.tags.filter.search.aria-label')}
          options={tagOptions}
          className="tik4-rs tik4-rs--sm tik4-rs--tfs"
          classNamePrefix="tik4-rs"
          //TODO: fix ts error (only occurs with loadable)
          // @ts-ignore
          onChange={handleChange}
          components={{
            ClearIndicator, 
            DropdownIndicator, 
            MultiValueRemove, 
            Placeholder, 
            NoOptionsMessage, 
            LoadingMessage,
            Option: CustomOption,
            // SingleValue: CustomSingleValue,
            MultiValue: CustomMultiValue
          }}
          // components={{ClearIndicator, DropdownIndicator, ValueContainer, Placeholder}}
          value={selectedOptions}
          // isClearable
          // defaultMenuIsOpen={true}
          // menuIsOpen={true}
          placeholder={t('liveblog.tags.filter.search.placeholder')}
          loadingMessage={() => t('liveblog.tags.filter.search.loading')}
          noOptionsMessage={() => t('liveblog.tags.filter.search.no_options')}



        />

      </div>
    </div>
  );
}

function ListFilter({tags, onChangeTags, selectedTags}: {tags: ITag[], onChangeTags?: OnChangeTagsHandler, selectedTags?: string[]}) {
  const {t} = useTranslation("liveblog");

  const onClick = useCallback((tag: ITag|undefined) => {
    if(onChangeTags) {
      if(!tag) {
        onChangeTags(undefined)
      } else if(selectedTags?.includes(tag._id!)) {
        onChangeTags(tags.filter(t => selectedTags?.includes(t._id!) && t._id !== tag._id))
      } else {
        onChangeTags(tags.filter(t => selectedTags?.includes(t._id!) || t._id === tag._id))
      }
    }
  }, [onChangeTags, selectedTags, tags])

  return <div className="tik4-tag-filter tik4-tag-filter--lf">
    <div className="tik4-tag-filter__label"><div className="tik4-tag-filter__label__i">{t('liveblog.tags.filter.headline')}</div></div>
    { (selectedTags) &&
      <button className="tik4-tag-filter__r tik4-link" onClick={() => onClick(undefined)}>
        <X className="tik4-icon tik4-tag-filter__r__i" /><span className="tik4-tag-filter__r__t">{t('liveblog.tags.filter.search.reset')}</span>
      </button>
    }
    <ul className="tik4-tag-filter__list">
      {tags.map(tag => <li className="tik4-tag-filter__list__item" key={tag._id}>
        <Tag tag={tag} onClick={onClick} selected={selectedTags?.includes(tag._id!)}/>
      </li>)}
    </ul>
  </div>
}

export function LiveblogTagFilter({tags, onChangeTags, selectedTags, eventTagNavigation}: LiveblogTagFilterProps) {
  if(eventTagNavigation === "filter-list" && tags.length <= FILTER_LIST_MAX_TAGS) {
    return <ListFilter tags={tags} onChangeTags={onChangeTags} selectedTags={selectedTags} />
  }
  if(eventTagNavigation === "filter-search" || (eventTagNavigation === "filter-list" && tags.length > FILTER_LIST_MAX_TAGS)) {
    return <SearchFilter tags={tags} onChangeTags={onChangeTags} selectedTags={selectedTags} />

  }
  return null;
}
